import type { ReactNode } from 'react'

/**
 * The reading in words, beside the map (Sprint 1.9.9 D2, D20).
 *
 * `word` and `line` are the reading's own `state_map.display.word` and
 * `.line`, verbatim; this component never chooses between words and holds none
 * of its own. The swatch's colour is one of the four token classes in
 * `mirror.css` (1.9.9 D-P7), and a reading with no quadrant has no swatch.
 * The badge and the confidence pill arrive finished from `Home.tsx`.
 */
export function QuadrantWord({
  token,
  word,
  line,
  badge,
  pill,
  testid = 'home',
}: {
  token: string | null
  word: string | null
  line: string | null
  badge: ReactNode
  pill: ReactNode
  /** The screen's test-id prefix: `home`, or `state` where `/state` reuses it (1.9.9 D38). */
  testid?: string
}) {
  return (
    <div className="qword">
      <div className="qword__head">
        {token !== null && <span className={`qword__swatch mirror-q--${token}`} aria-hidden="true" />}
        {word !== null && (
          <span className="qword__word" data-testid={`${testid}-word`}>
            {word}
          </span>
        )}
        {badge}
      </div>
      {line !== null && (
        <p className="qword__line" data-testid={`${testid}-line`}>
          {line}
        </p>
      )}
      {pill}
    </div>
  )
}
